import {NgModule} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {RecipeListComponent} from "./recipe/recipe-list/recipe-list.component";
import {RecipeEditComponent} from "./recipe/edit/recipe-edit/recipe-edit.component";
import {HomeComponent} from "./home/home.component";
import {AuthGuard} from "./guard/auth.guard";
import {LoginComponent} from "./login/login.component";
import {RegisterComponent} from "./register/register.component";
import {AdminComponent} from "./admin/admin.component";
import {ProfileComponent} from "./profile/profile.component";
import {VerifiedGuard} from "./guard/verified.guard";
import {UserVerificationComponent} from "./user-verification/user-verification.component";
import {UnauthenticatedGuard} from "./guard/unauthenticated.guard";
import {UnverifiedGuard} from "./guard/unverified.guard";
import {RecipeViewComponent} from "./recipe/view/recipe-view/recipe-view.component";
import {AdminGuard} from "./guard/admin.guard";
import {PendingChangesGuard} from "./guard/pending-changes.guard";

export const homePath = '/';

const routes: Routes = [
  { path: '', component: HomeComponent},
  { path: 'login', component: LoginComponent, canActivate: [UnauthenticatedGuard]},
  { path: 'registreren', component: RegisterComponent, canActivate: [UnauthenticatedGuard]},
  { path: 'wachten', component: UserVerificationComponent, canActivate: [AuthGuard, UnverifiedGuard]},
  { path: 'blocked', component: UserVerificationComponent, canActivate: [AuthGuard, UnverifiedGuard]},
  { path: 'profiel', component: ProfileComponent, canActivate: [AuthGuard]},
  { path: 'recepten', component: RecipeListComponent, canActivate: [AuthGuard, VerifiedGuard]},
  { path: 'recepten/create', component: RecipeEditComponent, canActivate: [AuthGuard, VerifiedGuard], canDeactivate: [PendingChangesGuard]},
  { path: 'recepten/:id', component: RecipeViewComponent, canActivate: [AuthGuard, VerifiedGuard]},
  { path: 'recepten/:id/edit', component: RecipeEditComponent, canActivate: [AuthGuard, VerifiedGuard], canDeactivate: [PendingChangesGuard]},
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard, AdminGuard]}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {})
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {

}
